<template>
<div>
  <v-container fluid grid-list-md>
    <v-app id="inspire">
      <NewEditDepartment style='float:left' v-on:create='create($event)'>
        <template v-slot:activator="{on}">
          <v-btn v-on="on">{{$t('department.new')}}</v-btn>
        </template>
      </NewEditDepartment>
      <v-data-table :headers=" headers" :items="departments" class="elevation-10">
        <template v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.description }}</td>
          <td>
            <NewEditDepartment style='float:left' v-on:update='update($event)' :department="props.item" />
            <v-btn small icon>
              <v-icon small fab block @click="deleteDepartment(props.item.id)">delete</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-app>
  </v-container>

</div>
</template>
<script>
import NewEditDepartment from './NewEdit'
export default {
  components: {
    NewEditDepartment
  },
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  data() {
    return {
      name: "",
      active: false,
      departments: [],
      headers: [{
          text: 'ID',
          value: "id",
        },
        {
          text: this.$t('department.name'),
          value: 'name'
        },
        {
          text: this.$t('department.description '),
          value: 'description'
        },
        {
          text: this.$t('department.actions'),
        }
      ]
    }
  },
  methods: {
    update(department) {
      this.$http.put('department/' + department.id, department).then(data => {
        let modelToUpdate = this.departments.find(el => el.id == department.id)
        modelToUpdate.description = department.description
        modelToUpdate.name = department.name
      })
    },
    create(department) {
      this.$http.post('department', department).then(data => {
        this.departments.push(data.data)
      })
    },
    loadDepartments() {
      this.$http.get('departments').then(data => {
        this.departments = data.data
      })
    },
    deleteDepartment(id) {
      this.$confirm(this.$t('related.delete_confirmation'))
        .then(res => {
          if (res) {
            this.$http.delete("department/" + id).then(() => {
              this.departments = this.departments.filter(el => el.id != id)
            })
          }
        })
    },
  },
  created() {
    this.loadDepartments()
  }
}
</script>

<style>
.loading-circle {
  margin: 20px;
}

.apexcharts-canvas.dark {
  background: transparent !important;
}

.filtr-active {
  background-color: green !important;
}
</style>
